import * as types from '../actions/ActionTypes';

const initialState = {
  loading: false,
  sectionsList: [],
  sectionRecord: null,
  redirectToList: false,
  validation_error: "",
  showUpdateForm: false,
  showViewPage: false,
};

const SectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SECTIONS_REQUEST:
      return { ...state, loading: true, redirectToList: false };
    case types.SECTIONS_SUCCESS:
      return { ...state, loading: false, sectionsList: action.sectionsList };
    case types.SECTIONS_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        sectionRecord: action.record,
        showUpdateForm: action.actionType === 'update',
        showViewPage: action.actionType === 'view',
      };
    case types.SECTIONS_VALIDATION_ERROR:
      return { ...state, loading: false, validation_error: action.validation_error };
    case types.SECTIONS_REDIRECT:
      return {
        ...state,
        redirectToList: true,
        showUpdateForm: false,
        showViewPage: false,
        sectionRecord: null,
      };
    case types.HIDE_SECTIONS_FIELD_VALIDATION_ERROR:
      if (state.validation_error && state.validation_error[action.feild_key])
        delete state.validation_error[action.feild_key];
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: action.validation_error,
      };
    default:
      return state;
  }
};

export default SectionReducer;
